export class BadEndpointException extends Error {
  readonly url: string;

  readonly method: string;

  readonly callerStack: string;

  constructor(url: string, method: string, callerStack: string) {
    super(
      `Bad endpoint: ${method} URL must not end with '/' before query params (${url})`
    );
    this.name = "BadEndpointException";
    this.url = url;
    this.method = method;
    this.callerStack = callerStack;
  }
}
